const nodes = {
  0: {
    id: 0,
    nid: 0,
    title: "L'affaire Maudet",
    text: '',
    group: 0,
    size: 1.25,
    strength: 1,
    disabled: false,
    icon: 'maudet.png',
    visited: 0,
    type: 0
  },
  1: {
    id: 1,
    nid: 1,
    title: 'Les acteurs',
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'main-acteurs.svg',
    visited: 0,
    type: 1
  },
  2: {
    id: 2,
    nid: 2,
    title: 'Un feuilleton judiciaire',
    text: '',
    group: 2,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'main-justice.svg',
    visited: 0,
    type: 1
  },
  3: {
    id: 3,
    nid: 3,
    title: 'Une saga politique',
    text: '',
    group: 3,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'main-politic.svg',
    visited: 0,
    type: 1
  },
  4: {
    id: 4,
    nid: 4,
    title: 'Les affaires',
    text: '',
    group: 4,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'main-affaires.svg',
    visited: 0,
    type: 1
  },
  5: {
    id: 5,
    nid: 5,
    title: 'Les dates clefs',
    text: '',
    group: 5,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'main-dates.svg',
    visited: 0,
    type: 1
  },
  6: {
    id: 6,
    nid: 6,
    title: "Ouverture d'une procédure",
    text:
      "<p>Le 30 août 2018, le Ministère public genevois saisit le parlement genevois d'une demande d'autorisation de poursuivre Pierre Maudet pour acceptation d'un avantage.</p><p>Détail peu habituel: le communiqué donne beaucoup d'éléments, au grand étonnement des observateurs. Il confirme que le conseiller d'État a été invité par le prince héritier de l'émirat, Mohamed Bin Zayed, que le financement réel de ce voyage a été dissimulé et que des «personnes et sociétés actives à Genève dans l'immobilier, en contact régulier avec Pierre Maudet et son chef de cabinet, ont activement pris part à la mise sur pied de ce voyage».</p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_ouverture_procedure.svg',
    visited: 0,
    type: 2
  },
  51: {
    id: 51,
    nid: 51,
    title: "Levée d'immunité",
    text:
      "<p>Le 20 septembre 2018, lors d'une séance à huis clos, le Grand Conseil accède à la demande du Ministère public et lève l'immunité du conseiller d'État, une décision que Pierre Maudet lui-même appelait de ses vœux. Il s'agit d'une première dans l'histoire pour un conseiller d'État en exercice.</p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_levee_imunite.svg',
    visited: 0,
    type: 2
  },
  7: {
    id: 7,
    nid: 7,
    title: 'Rebondissements judiciaires',
    text:
      "<p>Mardi 10 décembre, le quotidien Le Temps annonce s'être procuré le procès-verbal des auditions de deux entrepreneurs, Antoine Daher et Magid Khoury, qui ont organisé et facilité le voyage du magistrat à Abu Dhabi. </p><p> Ces témoignages recueillis par la justice le 5 décembre sont parvenus intégralement aux rédactions et comprennent jusqu’aux copies de pièces échangées entre les différents protagonistes. Les fuites sont dénoncées par l'avocat de Pierre Maudet, Me Grégoire Mangeat. Suite à cette publication, le Ministère public a décidé d'informer les membres du gouvernement des déclarations précises de Pierre Maudet. Dans un extrait de l’audition présenté aux conseillers d'Etat, le ministre qualifie son propre comportement de «totalement indigne de sa fonction». Les avocats de la défense demandent la récusation des trois procureurs. Demande rejetée par la Chambre pénale de recours en mai 2019.</p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_rebondissements.svg',
    visited: 0,
    type: 2
  },
  8: {
    id: 8,
    nid: 8,
    title: 'Perquisition de Simon Brandt',
    text:
      "<p>Vendredi 13 décembre 2019, le conseiller municipal Simon Brandt est arrêté, le temps de plusieurs perquisitions, dont une à son domicile. </p><p>L'élu sera également fouillé intégralement. La justice genevoise lui reproche alors une violation du secret de fonction. Il sera finalement blanchi mais contre-attaque en mars 2020, déposant plainte auprès du procureur général pour abus d'autorité, induction de la justice en erreur et violation du secret de fonction. </p><p>Selon lui, la justice genevoise l'a visé pour mieux toucher Pierre Maudet. La procédure a été ouverte et confiée au premier procureur Stéphane Grodecki, qui a co-instruit l'Affaire Maudet. </p><p>Près de deux mois après le dépot de plainte, Simon Brandt et Pierre Maudet demandent la récusation du magistrat, mettant en cause son indépendance. Ils sont déboutés par la Chambre pénale de recours. Le 11 novembre 2020, le Tribunal fédéral rejette à son tour le recours de l’élu PLR. Stéphane Grodecki reste donc en charge de l’enquête menée contre le policier genevois qui a procédé à la fouille de Simon Brandt. </p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_perquisition_brandt.svg',
    visited: 0,
    type: 2
  },
  10: {
    id: 10,
    nid: 10,
    title: "Annonce de l'ouverture d'un procès",
    text:
      "<p>Le 30 juin 2020, le Ministère public informe les prévenus de son intention de les renvoyer en jugement, concernant le volet Abu Dhabi, mais aussi la délivrance de l'autorisation d'exploitation de l'Escobar, et enfin pour des violations de secrets de fonction.</p><p>Sont concernés: Pierre Maudet (pour acceptation d'un avantage), Patrick Baud-Lavigne (pour acceptation d'un avantage, abus d'autorité et violation du secret de fonction), Raoul Schrumpf (abus d'autorité), Antoine Daher et Magid Khoury (pour octroi d'un avantage).</p><p>L'acte d'accusation est déposé au Tribunal de police le 3 novembre 2020. Le procès se tiendra du 15 au 19  février 2021, alors que Pierre Maudet sera en pleine période électorale pour sa propre succession au poste de Conseiller d'Etat.</p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_ouverture_proces.svg',
    visited: 0,
    type: 2
  },
  9: {
    id: 9,
    nid: 9,
    title: 'Classement partiel',
    text:
      "<p>Le 1er juillet 2020, faute de cadre légal définissant clairement les limites du financement de la vie politique, le Ministère public annonce classer le volet Manotel ainsi que le volet du financement de l’anniversaire du magistrat à l’Escobar. 105'000 francs avaient été versés par l'hôtelier au comité de soutien Pierre Maudet et le groupe avait également financé l'anniversaire du magistrat le 6 mars 2018.</p>",
    group: 2,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'justice_classement_partiel.svg',
    visited: 0,
    type: 2
  },
  11: {
    id: 11,
    nid: 11,
    title: 'Maudet tout puissant',
    text:
      "<p>En 2012, Pierre Maudet créé la surprise et ravit le siège laissé vacant par la démission du conseiller d'Etat PLR Mark Muller. Il apparaît plus fort que jamais. Ses amis comme ses adversaires lui reconnaissent un sens aigu de la politique et une capacité de travail exceptionnelle. En 2018, il est réélu dès le premier tour et se retrouve en charge du vaste Département de la Sécurité et de l’Économie. L'avenir semble tout tracé, au point de regarder du côté de Berne.</p>",
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_tout_puissant.svg',
    visited: 0,
    type: 2
  },
  12: {
    id: 12,
    nid: 12,
    title: 'En route pour le Conseil Fédéral',
    text:
      '<p>Vendredi 4 août 2017, Pierre Maudet se déclare publiquement candidat au Conseil fédéral. </p><p>«Je vais à Berne pour parler des sujets de fond», dit-il à la «Tribune de Genève». Face à lui, le tessinois Ignazio Cassis et la vaudoise Isabelle Moret. Mais le Parlement fait finalement le choix tessinois.</p>',
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_candidat.svg',
    visited: 0,
    type: 2
  },
  13: {
    id: 13,
    nid: 13,
    title: 'Le vacillement',
    text:
      "<p>Premières suspicions évoquées dans la presse concernant le financement du voyage en terres émiraties en 2015, création d'une sous-commission d'enquête du parlement genevois puis ouverture d'une procédure pénale par la justice genevoise: le 5 septembre 2018, Pierre Maudet, acculé, concède avoir «caché une partie de la vérité». </p><p>Politiquement, le PLR est affaibli. La perspective de lui retirer des dossiers et de réduire l'envergure de son département est alors claire.</p>",
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_vacillement.svg',
    visited: 0,
    type: 2
  },
  14: {
    id: 14,
    nid: 14,
    title: 'Dépossession des prérogatives',
    text:
      "<p>Suite à l'aveu de Pierre Maudet d'avoir «caché une partie de la vérité» le 5 septembre 2018, le Conseil d’État annonce qu’il retire au ministre certaines de ses prérogatives, à savoir la représentation du gouvernement et toute relation institutionnelle avec le pouvoir judiciaire.</p><p>Le 18 septembre 2018, Pierre Maudet déclare renoncer à la présidence du Conseil d’État de Genève et se voit retirer la responsabilité de l’Aéroport et de la police.</p><p> Le 20 septembre, le Grand conseil lève l'immunité de Pierre Maudet, une mesure inédite à Genève pour un Conseiller d’État en fonction.</p>",
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_depossession_prerogatives.svg',
    visited: 0,
    type: 2
  },
  15: {
    id: 15,
    nid: 15,
    title: 'Exclusion du PLR',
    text:
      "<p>Pierre Maudet refuse en bloc de démissioner et s'accroche au pouvoir. Fin juin 2019, parce qu'il entame sa 8e année à l'exécutif, il peut bénéficier, dès son départ du gouvernement, d'une rente à vie d'environ 89'000 francs ou à 7400 francs par mois. </p><p>Suite à de nouvelles fuites dans la presse, le comité directeur du parti cantonal agende le 6 juillet 2020 une séance au cours de laquelle il se prononce en faveur d’une exclusion du conseiller d’État, déjà prévenu d’acceptation d’un avantage pour son voyage à Abu Dhabi en 2015. </p><p>La veille, le magistrat PLR avait adressé une lettre à son parti pour dénoncer un «simulacre de procès politique». La décision d'exclusion du PLR Genève est prise par 22 voix contre 1 opposition et 1 abstention. Pierre Maudet n'est désormais également plus membre du PLR Suisse. </p><p>Il annonce début août 2020 ne pas faire recours contre cette décision et vouloir siéger désormais en tant qu’indépendant.</p>",
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_exclusion_plr.svg',
    visited: 0,
    type: 2
  },
  53: {
    id: 53,
    nid: 53,
    title: 'La démission',
    text:
      "<p> Le 28 octobre 2020, un audit lié à de «graves dysfonctionnements» au sein des services de Pierre Maudet conduit le Conseil d’État à en dessaisir temporairement le magistrat. L’auteure du rapport s'inquiète de la santé physique et psychique des collaborateurs de la direction générale du développement économique. </p><p>Le lendemain de cette décision qu'il qualifie «d’exécution politique cousue de fil blanc», Pierre Maudet annonce sa démission du Conseil d'Etat, et déclare dans le même temps qu'il sera candidat à sa propre succession, pour les élections de mars 2021.</p>",
    group: 3,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'politique_demission.svg',
    visited: 0,
    type: 2
  },
  16: {
    id: 16,
    nid: 16,
    title: 'Abu Dhabi',
    text:
      "<p>C'est le dossier qui constitue le coeur de l'affaire Maudet. En novembre 2015, Pierre Maudet se voit offrir un très luxueux séjour en famille à Abu Dhabi, agrémenté de cadeaux. Il affirme qu'il s'agit d'un voyage privé.</p><p>Deux ans et demi plus tard, suite à une déclaration du Ministère public qui ouvre une procédure, Pierre Maudet avoue que le déplacement a en réalité été payé par le prince héritier des Émirats et c'est bel et bien en sa qualité de ministre qu'il s'est rendu sur place.</p><p>Pierre Maudet et son ancien chef de cabinet Patrick Baud-Lavigne sont aujourd'hui prévenus par le Ministère public d’acceptation d’un avantage pour avoir participé à ce voyage. Les entrepreneurs Antoine Daher et Magid Khoury se voient quant à eux reprocher l’octroi d’un avantage pour leur implication dans l’organisation de ce séjour.</p><p><img src='https://interactif.24heures.ch/2020/affaire-maudet/maudet_abu_dhabi.jpg' /><small>Le 28 novembre 2015, Pierre Maudet a visité le centre de vidéosurveillance en compagnie du vice-président de l’Emirat et chef de la sécurité intérieure, Hazza bin Zayed. C'est la seule photo officielle du séjour.</small></p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_abu_dhabi.svg',
    visited: 0,
    type: 2
  },
  17: {
    id: 17,
    nid: 17,
    title: "L'aéroport",
    text:
      "<p>En octobre 2015, l'aéroport de Genève a ouvert un appel d’offres pour le renouvellement des concessions de ses sociétés de service au sol. Lors de son séjour à Abu Dhabi un mois plus tard, le ministre était accompagné de son chef de cabinet, Patrick Baud-Lavigne, également représentant du Département genevois de la sécurité et de l’économie au conseil de direction de Cointrin. Quatre mois plus tard, c'est une société émiratie pourtant controversée, Dnata, qui remporte l’une des concessions. Pierre Maudet a néanmoins toujours affirmé que son voyage n'avait impliqué aucune contrepartie.</p><p>L'affaire, révélée par la presse en mai 2018, éclabousse également le projet de réaménagement de la zone Pré-du-Stand puisque la société qui investit appartient au promoteur Magid Khoury, impliqué dans l'organisation du voyage controversé à Abu Dhabi.</p><p>Aucun lien avec Pierre Maudet n'a pu être démontré à ce stade dans ces deux dossier et aucun volet pénal n'est en cours dans ces affaires.</p><p><img src='https://interactif.24heures.ch/2020/affaire-maudet/maudet_aeroport.jpg' /><small>Du tri des bagages à l’entretien des avions par grand froid, les activités des entreprises d’assistance au sol sont multiples. (MAGALI GIRARDIN)</small></p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_aeroport.svg',
    visited: 0,
    type: 2
  },
  18: {
    id: 18,
    nid: 18,
    title: 'Manotel',
    text:
      "<p>Entre 2012 et 2018, deux associations pilotées par Pierre Maudet ont reçu plus de 100'000 francs de la part de Manotel.</p><p>Le groupe hôtelier a également offert au ministre un apéritif d’anniversaire dans l'un de ses hôtels, le 6 mars 2018, d’une valeur d’environ 20'000 francs, facturée 10'000. Près de 200 invités sont présents à la fête, parmi lesquels le procureur Olivier Jornot ou encore la cheffe de la police, Monica Bonfanti.</p><p>Après avoir soupçonné Pierre Maudet d'avoir favorisé Manotel lors des pourparlers syriens entre 2015 et 2017, le Ministère public rend au début du mois de juillet 2020 une ordonnance de classement sur ce volet de l'affaire.</p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_manotel.svg',
    visited: 0,
    type: 2
  },
  19: {
    id: 19,
    nid: 19,
    title: 'Les caisses noires',
    text:
      "<p>En 2018, les instances du PLR découvrent l'existence de deux associations cachées, pilotées par Pierre Maudet. </p><p>Le Cercle Fazy-Favon, association non affiliée au PLR, sans activités publiques et créé à l’heure de la fusion avec les libéraux en 2011, possède près de 230'000 francs sur son compte, dont Pierre Maudet est seul à disposer de la signature. </p><p>«L’association de soutien à Pierre Maudet» a également été dissimulée durant six ans. Plus de 100'000 francs de «soutien politique» ont été versés sur ces comptes secrets par Manotel. Des caisses noires qui ont notamment servi à payer les cotisations du magistrat au PLR, à hauteur de 10'000 francs par an. </p><p>Si l'affaire a fortement ébranlé le parti, aucun volet pénal n'est en cours dans ce dossier.</p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_boite_noire.svg',
    visited: 0,
    type: 2
  },
  20: {
    id: 20,
    nid: 20,
    title: "L'Escobar",
    text:
      "<p>En octobre 2017, le bar l’Escobar, établissement des Grottes dans lequel Antoine Daher a investi, situé dans un immeuble qui appartient au groupe Capvest de Magid Khoury, s'est vu délivrer une autorisation d'ouverture expresse. L'autorisation est arrivée seulement neuf jours après le dépôt de la demande, alors que le temps d'attente avoisine généralement les deux mois, que le dossier était incomplet et que la fonctionnaire chargée de l'affaire avait donné un préavis négatif.</p><p>Pierre Maudet était présent à l'inauguration des lieux et y a même fêté son anniversaire le 3 mars 2018. Le Ministère public genevois n’a pas retenu de charges envers le ministre dans ce dossier, mais Raoul Schrumpf, l’ancien chef de la police du commerce et Patrick Baud-Lavigne, l'ancien chef de cabinet de Pierre Maudet, sont tous deux prévenus d’abus d’autorité pour avoir autorisé l’ouverture du bar malgré un dossier incomplet. Des faits que la défense conteste.</p><p><img src='https://interactif.24heures.ch/2020/affaire-maudet/maudet_escobar.jpg' /><small>L'émission Temps Présent de la RTS a pu se procurer une capture d’écran qui confirme la rapidité de la procédure d’autorisation. On y voit écrit «autorisation WORD à la demande du magistrat», ce qui signifie que le magistrat a été mentionné dans la procédure. (RTS)</small></p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_escobar.svg',
    visited: 0,
    type: 2
  },
  21: {
    id: 21,
    nid: 21,
    title: 'Le sondage',
    text:
      "<p>Antoine Daher, alors dirigeant de la société Renovis qui appartient au groupe de Magid Khoury, a participé à la récolte de 35'000 francs pour financer un sondage Ipsos pour sa campagne de 2017. Magid Khoury avait accepté de participer à hauteur de 15'000 francs.</p><p> Dans le cadre de cette affaire, le ministre et son ancien chef de cabinet, Patrick Baud-Lavigne, sont prévenus d'acceptation d’un avantage. Magid Khoury et Antoine Daher sont prévenus d'octroi d’un avantage pour avoir participé à financer le sondage.</p>",
    group: 4,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'nodes_pictos_main-affaires_sondage.svg',
    visited: 0,
    type: 2
  },
  22: {
    id: 22,
    nid: 22,
    title: "L'affaire éclate",
    text:
      "<p>La Tribune de Genève révèle le voyage à Abu Dhabi en 2015 et s'interroge sur la prise en charge des frais. Pierre Maudet, alors ministre chargé de la Sécurité et de l’Économie, donne des explications peu convaincantes. Il affirme notamment avoir pris en charge une partie des frais de ce voyage, qu'il qualifie de «privé».</p>",
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_affaire_eclate.svg',
    visited: 0,
    type: 2
  },
  23: {
    id: 23,
    nid: 23,
    title: "Ouverture d'une procédure",
    text:
      "<p>Le 30 août 2018, le Ministère public saisit le Grand Conseil d’une demande d’autorisation de poursuivre Pierre Maudet pour acceptation d’un avantage concernant le voyage à Abu Dhabi en 2015. Les éléments de preuve recueillis conduisent également à ouvrir l’instruction contre le chef de cabinet Patrick Baud-Lavigne, qui a quitté ses fonctions deux mois plus tôt.</p><p><img src='https://interactif.24heures.ch/2020/affaire-maudet/maudet_procedure.jpg' /><small>La Une de la Tribune de Genève, qui a révélé l'affaire, au lendemain de l'annonce d'une procédure.</small></p>",
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_procedure.svg',
    visited: 0,
    type: 2
  },
  24: {
    id: 24,
    nid: 24,
    title: "L'aveu",
    text:
      '<p>Le 5 septembre 2018, en direct lors de l’émission «Genève à Chaud» de Léman Bleu, Pierre Maudet fait son mea culpa et admet avoir caché une partie de la vérité. </p><p>Les conséquences sont immédiates. Lors du point de presse hebdomadaire, le Conseil d’État annonce qu’il retire au ministre certaines de ses prérogatives, à savoir la représentation du gouvernement et toute relation institutionnelle avec le pouvoir judiciaire. </p><p>Le 18 septembre, Pierre Maudet annonce renoncer à la présidence du Conseil d’État de Genève et se voit retirer la responsabilité de l’Aéroport et de la police. </p><p>Le 20 septembre, le Grand conseil lève l’immunité de Pierre Maudet, une mesure inédite à Genève pour un Conseiller d’État en fonction.</p>',
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_verite.svg',
    visited: 0,
    type: 2
  },
  25: {
    id: 25,
    nid: 25,
    title: "Annonce de l'ouverture d'un procès",
    text:
      "<p>Le parquet renvoie devant le Tribunal de police Pierre Maudet et ses quatre partenaires, les entrepreneurs Antoine Daher et Magid Khoury, son ex-chef de cabinet Patrick Baud-Lavigne et Raoul Schrumpf, ex-responsable du service du commerce.</p><p>Le parquet poursuit Pierre Maudet pour son voyage à Abu Dhabi en novembre 2015, et pour le sondage sur sa popularité financé par un tiers durant sa campagne en 2017. Le 28 août 2020, Les avocats de Magid Khoury ont demandé au Ministère public que de nouvelles auditions aient lieu, en lien avec le financement du sondage de campagne de Pierre Maudet en 2017. Le parquet refuse.</p><p>Début juillet 2020, lors d'une conférence de presse, l'élu annonce qu’en cas de condamnation lors du futur procès, il démissionnera.</p><p> Finalement, il démissionnera de lui-même le 29 octobre 2020, quelques mois avant la tenue du procès.</p><p> Le procès se tiendra du 15 au 19 février 2021.</p>",
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_ouverture_proces.svg',
    visited: 0,
    type: 2
  },
  26: {
    id: 26,
    nid: 26,
    title: 'Exclusion du PLR',
    text:
      "<p>Début juillet 2020, de troublants échanges WhatsApp entre Pierre Maudet et Simon Brandt paraissent dans la presse. Les deux politiciens y évoquent la possibilité de modifier un PV de la section Ville du PLR, concernant le financement par le groupe Manotel de l'anniversaire de Pierre Maudet en 2018.</p><p>Suite à ces révélations, le comité directeur du parti cantonal agende une séance au cours de laquelle il se prononce en faveur d’une exclusion du conseiller d’État, déjà prévenu d’acceptation d’un avantage pour son voyage à Abu Dhabi en 2015. La décision a été prise par 22 voix contre 1 opposition et 1 abstention. Pierre Maudet a trente jours pour faire recours, mais il est exclu de fait dès ce moment et n'est également plus membre du PLR Suisse.</p>",
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_exclusion_plr.svg',
    visited: 0,
    type: 2
  },
  54: {
    id: 54,
    nid: 54,
    title: 'La démission',
    text:
      "<p>Le 29 octobre 2020, au lendemain de la perte provisoire de son Département du développement économique sur décision du Conseil d'Etat, Pierre Maudet annonce sa démission. Lors de cette conférence de presse, il précise ne pas vouloir se lancer dans une bataille judiciaire et déclare qu'il sera candidat à sa propre succession à l’élection complémentaire du 7 mars 2021.</p>",
    group: 5,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'date_demission.svg',
    visited: 0,
    type: 2
  },
  27: {
    id: 27,
    nid: 27,
    title: 'Les acteurs politiques',
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'nodes_pictos_main-acteurs_politique.svg',
    visited: 0,
    type: 1
  },
  28: {
    id: 28,
    nid: 28,
    title: 'Les acteurs judiciaires',
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'nodes_pictos_main-acteurs_judiciaire.svg',
    visited: 0,
    type: 1
  },
  29: {
    id: 29,
    nid: 29,
    title: "Les hommes d'affaire",
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'nodes_pictos_main-acteurs_lebanese.svg',
    visited: 0,
    type: 1
  },
  30: {
    id: 30,
    nid: 30,
    title: 'Maudet et sa garde',
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'nodes_pictos_main-acteurs_garde.svg',
    visited: 0,
    type: 1
  },
  31: {
    id: 31,
    nid: 31,
    title: 'Les acteurs internationaux',
    text: '',
    group: 1,
    size: 1,
    strength: 1,
    disabled: false,
    icon: 'nodes_pictos_main-acteurs_internationaux.svg',
    visited: 0,
    type: 1
  },
  32: {
    id: 32,
    nid: 32,
    title: 'Christian Lüscher',
    text:
      "<p>Le conseiller national PLR a été l'un des plus virulents à l'encontre du conseiller d'État. L'élu a appelé publiquement Pierre Maudet à démissionner «par amour du PLR».</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'luscher.png',
    visited: 0,
    type: 2
  },
  33: {
    id: 33,
    nid: 33,
    title: 'Serge Dal Busco',
    text:
      "<p>Le conseiller d'État PDC se situe en périphérie de l'affaire Maudet. Le magistrat a confirmé en 2019 avoir aussi reçu une somme (d'un montant de 10'000 francs) de la part du groupe Manotel entre les deux tours de la campagne 2018. L'élu déclare avoir «spontanément» restitué ce don cinq mois plus tard.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'busco.png',
    visited: 0,
    type: 2
  },
  34: {
    id: 34,
    nid: 34,
    title: 'Alexandre de Senarclens',
    text:
      "<p>Cet ancien président du PLR avait souhaité la démission de Pierre Maudet. Face à l'assemblée générale des délégués, l'avocat s'est retrouvé minoré et contraint à la démission.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'senarclens.png',
    visited: 0,
    type: 2
  },
  35: {
    id: 35,
    nid: 35,
    title: 'Simon Brandt',
    text:
      "<p>Soupçonné d’avoir consulté des fichiers de la police pour informer Pierre Maudet d’une affaire interne aux Jeunes PLR, cet ancien collaborateur personnel du ministre a été arrêté en décembre 2019, puis blanchi. Le domicile du conseiller municipal en Ville de Genève a toutefois été perquisitionné, et l'élu PLR fouillé à nu. Ce qui l'a poussé à déposer notamment une plainte pour abus d'autorité. Selon lui, la justice genevoise l'a visé pour mieux toucher Pierre Maudet.</p><p>En grande partie à cause de cette affaire, le PLR n'a pas réussi à obtenir un siège à l'Exécutif de la Ville. En juillet 2020, des échanges WhatsApp entre Simon Brandt et Pierre Maudet fuitent dans la presse. Ils concernent la fête d’anniversaire de ce dernier en 2018, payée par le groupe hôtelier Manotel. Les deux interlocuteurs évoquent notamment par écrit la possibilité de modifier un PV de la section Ville du PLR lié à ce financement, dont Simon Brandt était le président cette année-là.</p><p>Si Simon Brandt assure n’avoir jamais rien fait de répréhensible, il quitte ses fonctions de vice-président et de membre du Comité du PLR Ville de Genève après ces révélations.</p><p> Le 17 novembre 2020, l’ancien député et actuel conseiller municipal est condamné pour violation du secret de fonction, selon le Ministère public. L’élu PLR écope de 80 jours-amende à 170 francs, d’une amende de 2720 francs et devra s’acquitter de la moitié des frais de la procédure. Celle-ci a été ouverte lorsqu’un rapport confidentiel sur les frais des fonctionnaires de la Ville de Genève a transpiré dans la presse à la mi-décembre 2018. La Ville de Genève avait porté plainte suite à cette fuite. Le procureur général fonde sa décision de condamner Simon Brandt sur un échange de SMS entre celui-ci et Pierre Maudet, dans lequel le duo semble orchestrer la fuite dans la presse dudit rapport. Simon Brandt a fait opposition, ce qui entraînera un procès public.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'brandt.png',
    visited: 0,
    type: 2
  },
  36: {
    id: 36,
    nid: 36,
    title: 'Petra Gössi',
    text:
      '<p>La présidente du PLR Suisse a demandé la démission de Pierre Maudet à deux reprises. Cette demande est non coercitive, les sections cantonales étant indépendantes. «Je pense que les électeurs ont compris que le comportement de Pierre Maudet n’est en rien le reflet des valeurs du PLR», avait déclaré la Schwytzoise en janvier 2019.</p>',
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'gossi.png',
    visited: 0,
    type: 2
  },
  37: {
    id: 37,
    nid: 37,
    title: 'Jean Batou',
    text:
      "<p>Né en 1954, Jean Batou est professeur honoraire à l'Université de Lausanne, spécialiste d'histoire internationale. Député d’Ensemble à Gauche, il est l’un des plus farouches opposants au conseiller d’État Pierre Maudet.</p><p>Dans une question écrite urgente au Conseil d’État en mai 2018, il demandait si l’invitation à Abu Dhabi avait joué dans la décision de l’octroi de la concession pour 7 ans supplémentaires d’une partie des services au sol à l’Aéroport International de Genève à la société émiratie Dnata.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'batou.png',
    visited: 0,
    type: 2
  },
  38: {
    id: 38,
    nid: 38,
    title: 'Olivier Jornot',
    text:
      "<p>Le procureur général du canton de Genève a instruit la procédure pour «acceptation d'un avantage» à l'encontre de Pierre Maudet. C'est lui qui a invité le Conseil d'État à retirer le département de la Sécurité à l'édile.</p><p>Pugnace, cet ancien député PLR a insruit le dossier assisté des premiers procureurs Yves Bertossa et Stéphane Grodecki mais seul ce dernier portera l’accusation au Tribunal de police. L'inimitié d'Olivier Jornot avec Pierre Maudet est connue dans le monde politique et judiciaire.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'jornot.png',
    visited: 0,
    type: 2
  },
  39: {
    id: 39,
    nid: 39,
    title: 'Stéphane Grodecki',
    text:
      "<p>Premier procureur au même titre de Yves Bertossa, il dirige la procédure pénale contre Pierre Maudet sous la houlette d'Olivier Jornot. Une demande de récusation formulée par l'avocat du magistrat contre les trois procureurs a été rejetée par la Chambre pénale de recours en mai 2019. En novembre 2020, une demande de récusation de Stéphane Grodecki par Simon Brandt est rejetée par le Tribunal fédéral. Docteur en droit, magistrat expérimenté, rompu à l’exercice des procès d’envergure, c'est lui qui soutiendra l'accusation au Tribunal de police.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'grodecki.png',
    visited: 0,
    type: 2
  },
  40: {
    id: 40,
    nid: 40,
    title: 'Yves Bertossa',
    text:
      "<p>Premier procureur, avec Stéphane Grodecki, à instruire la procédure pénale contre Pierre Maudet. Une demande de récusation formulée par l'avocat du magistrat contre les trois procureurs a été rejetée par la Chambre pénale de recours en mai 2019. </p><p>Le magistrat s'est fait connaître en ordonnant l’arrestation de Hannibal Kadhafi. Il est également le fils de l’ancien procureur général Bernard Bertossa, comme lui socialiste.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'bertossa.png',
    visited: 0,
    type: 2
  },
  41: {
    id: 41,
    nid: 41,
    title: 'Me Grégoire Mangeat',
    text:
      "<p>Il est le principal défenseur de Pierre Maudet, appuyé par Me Fanny Margairaz et Me Yaël Hayat. </p><p> Me Grégoire Mangeat a plusieurs fois déploré les fuites de documents – dont des procès verbaux d'audition – dans la presse.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'mangeat.png',
    visited: 0,
    type: 2
  },
  42: {
    id: 42,
    nid: 42,
    title: 'Saïd Bustany',
    text:
      "<p>Saïd Bustany est le directeur général de la société Emirates National Establishment, une société privée active dans l’immobilier, les télécommunications et le domaine aéroportuaire, autre autres. Proche du pouvoir emirati, il a d'abord été présenté par Pierre Maudet et sa garde rapprochée comme étant le généreux financier du voyage à Abu Dhabi.</p><p>Après l'audition de son ami Antoine Daher par deux procureurs le 5 décembre 2018, audition au cours de laquelle il mentionne l'existence de Saïd Bustany, Pierre Maudet lui envoie ce message: «Well done, Old Chap.» (ndlr: «Bien joué, mon vieux.»). Le Ministère public genevois, après enquête, révèle que l’homme d’affaires libanais «n’a joué aucun rôle dans le financement du voyage».</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'bustany.svg',
    visited: 0,
    type: 2
  },
  43: {
    id: 43,
    nid: 43,
    title: 'Antoine Daher',
    text:
      "<p>Antoine Daher est prevenu d’octroi d’un avantage pour avoir mis sur pied le séjour à Abu Dhabi, et également d'octroi d'un avantage pour avoir participé à financer le sondage organisé lors de la campagne électorale de 2017.</p><p>Directeur de Renovis au moment des faits – une entreprise de rénovation appartenant à Capstone, le groupe de Magid Khoury – Antoine Daher est un ami de Pierre Maudet. Ils se sont rencontrés dans un avion pour Beyrouth en 2014, alors que Pierre Maudet était déjà conseiller d'Etat. Il a également organisé et cofinancé l'anniversaire de l'édile dans le bar du quartier des Grottes, l'Escobar, pour lequel il avait réussi à obtenir une autorisation d'ouverture en un temps record.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'daher.png',
    visited: 0,
    type: 2
  },
  44: {
    id: 44,
    nid: 44,
    title: 'Magid Khoury',
    text:
      "<p>Magid Khoury, homme d’affaires actif dans l’immobilier, est prévenu d’octroi d’un avantage pour avoir participé au voyage à Abu Dhabi, et également d'octroi d'un avantage pour avoir participé à financer le sondage organisé lors de la campagne électorale de 2017.</p><p>Actionnaire majoritaire de Capvest et actionnaire à 100% de Capstone (qui détient notamment Renovis, dont Antoine Daher était directeur), la valeur de son groupe est estimée entre 50 et 100 millions de francs.</p><p>Il sollicite son oncle, Charbel Ghanem, pour faire inscrire le conseiller d'État sur la liste d'invités du Grand Prix de Formule 1 d'Abu Dhabi.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'khoury.png',
    visited: 0,
    type: 2
  },
  45: {
    id: 45,
    nid: 45,
    title: 'La famille Ghanem',
    text:
      "<p>Charbel Ghanem est l'oncle de Magid Khoury. Proche du pouvoir émirien, lui et son fils ont participé à l’organisation du voyage de Pierre Maudet à Abu Dhabi. Son fils Philippe était, à l'époque des faits et selon son profil Linkedin, CEO du groupe ADS Securities, société financière basée à Abu Dhabi au capital de 400 millions de dollars, et président de l’antenne genevoise d’ADSS, une société désormais en liquidation, administrée alors par le frère de Magid Khoury.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'ghanem.svg',
    visited: 0,
    type: 2
  },
  47: {
    id: 47,
    nid: 47,
    title: 'Patrick Baud-Lavigne',
    text:
      "<p>Le bras droit. L'ancien chef de cabinet de Pierre Maudet a quitté ses fonctions en juin 2018 suite aux révélations du voyage à Abu Dhabi de son magistrat, auquel il participait également.</p><p>Ancien conseiller municipal socialiste en Ville de Genève, ancien directeur général de Naxoo – le câblo-opérateur de la Ville de Genève – Patrick Baud-Lavigne, était directeur de cabinet de Pierre Maudet depuis 2014. Il avait la main sur des dossiers chauds, liés entre autres aux taxis, à la Sécurité, à l’Aéroport.</p><p>À moult reprises, il a désamorcé – ou a tenté de le faire – des situations politiquement délicates. Il est prévenu d'abus d'autorité dans l'ouverture accélérée de l'Escobar, d'acceptation d'un avantage pour avoir participé au voyage à Abu Dhabi, d'acceptation d’un avantage dans le cadre du sondage organisé lors de la campagne électorale de 2017 et de violation du secret de fonction pour avoir transmis à Antoine Daher des informations confidentielles relatives à des dossiers en cours.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'lavigne.png',
    visited: 0,
    type: 2
  },
  48: {
    id: 48,
    nid: 48,
    title: 'Raoul Schrumpf',
    text:
      "<p>Le fusible. Cet ancien chef de la police du commerce est prévenu d’abus d’autorité pour avoir facilité l’octroi d’une autorisation d’exploiter l’Escobar malgré un dossier incomplet, le tout à la demande d'Antoine Daher, ami de Pierre Maudet.</p><p>Une fois impliqué, Raoul Schrumpf a demandé à être suspendu, puis il a été réaffecté à la planification pénitentiaire.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'schrumpf.png',
    visited: 0,
    type: 2
  },
  49: {
    id: 49,
    nid: 49,
    title: 'Mohammed Bin Zayed',
    text:
      "<p>Au tout début de l'affaire dans les interviews, Pierre Maudet déclare avoir rencontré «fortuitement» lors de son voyage controversé à Abu Dhabi le prince héritier Mohammed Bin Zayed «dans le hall de l'Emirates Palace».</p><p>Le conseiller d'État l'avait déjà rencontré à Dubaï en mai 2015, lors d'une visite officielle de la délégation économique du canton.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'zayed.png',
    visited: 0,
    type: 2
  },
  50: {
    id: 50,
    nid: 50,
    title: 'Hazza Bin Zayed',
    text:
      "<p>Lors de son séjour à Abu Dhabi, Pierre Maudet a également rencontré le vice-président de l’Émirat et chef de la sécurité intérieure, Hazza Bin Zayed.</p><p>Il ressort des procès-verbaux d'audition qu'en septembre 2016, ce dernier espérait entretenir avec Genève une «coopération bilatérale dans les domaines de la finance et de la sécurité». C’est ce qu’indique un mail alors envoyé à Patrick Baud-Lavigne et qui répondait à un courrier de Pierre Maudet du début de l’année.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'hazza.png',
    visited: 0,
    type: 2
  },
  52: {
    id: 52,
    nid: 52,
    title: 'Pierre Maudet',
    text:
      "<p>Pierre Maudet, né le 6 mars 1978 à Genève, est un homme politique de nationalité franco-suisse, jusqu'à peu membre du Parti libéral-radical genevois, avant d'en être exclu suite à une multitude de révélations connues désormais sous le nom de «L'affaire Maudet».</p><p>Longtemps considéré comme l'enfant chéri du parti radical, il a été élu au Conseil municipal de la ville de Genève, puis au Conseil administratif du 1er juin 2007 au 20 juin 2012, dont il a été le plus jeune maire de l'histoire. Candidat malheureux au Conseil fédéral en 2017, il était Conseiller d'État depuis le 29 juin 2012 et a démissionné en novembre 2020. </p><p>Il est actuellement accusé d’acceptation d’un avantage pour avoir bénéficié d'un voyage à Abu Dhabi et d'acceptation d’un avantage dans le cadre du sondage organisé lors de la campagne électorale de 2017. En attendant le procès qui s'ouvre le 15 février 2021, ce sont les différents aspects de ce qui compose l'Affaire Maudet que nous vous proposons d'explorer ici.</p>",
    group: 6,
    size: 1,
    strength: 1,
    disabled: true,
    icon: 'maudet.png',
    visited: 0,
    type: 2
  }
}
const data = { nodes: [nodes[0]], links: [] }
const groups = {
  0: [nodes[1], nodes[2], nodes[3], nodes[4], nodes[5]],
  1: [nodes[27], nodes[28], nodes[29], nodes[30], nodes[31]],
  2: [nodes[6], nodes[51], nodes[7], nodes[8], nodes[10], nodes[9]],
  3: [nodes[11], nodes[12], nodes[13], nodes[14], nodes[15], nodes[53]],
  4: [nodes[16], nodes[17], nodes[18], nodes[19], nodes[20], nodes[21]],
  5: [nodes[22], nodes[23], nodes[24], nodes[25], nodes[26], nodes[54]],
  6: [],
  51: [],
  7: [],
  8: [],
  10: [],
  9: [],
  11: [],
  12: [],
  13: [],
  14: [],
  15: [],
  53: [],
  16: [],
  17: [],
  18: [],
  19: [],
  20: [],
  21: [],
  22: [],
  23: [],
  24: [],
  25: [],
  26: [],
  54: [],
  27: [nodes[32], nodes[33], nodes[34], nodes[36], nodes[37]],
  28: [nodes[38], nodes[39], nodes[40], nodes[41]],
  29: [nodes[42], nodes[43], nodes[44], nodes[45]],
  30: [nodes[35], nodes[47], nodes[48], nodes[52]],
  31: [nodes[49], nodes[50]],
  32: [],
  33: [],
  34: [],
  35: [],
  36: [],
  37: [],
  38: [],
  39: [],
  40: [],
  41: [],
  42: [],
  43: [],
  44: [],
  45: [],
  47: [],
  48: [],
  49: [],
  50: [],
  52: []
}
export { data, groups }
